import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ICategoryPostData {
  id?: string;
  name: string;
  description: string;
  active: boolean;
  is_paid: boolean;
  in_hours: boolean;
  color?: string;
  user_ids: string[];
  accrue_per_period: string;
  accrue_type?: string;
  accrue_period: string;

  // Waiting period
  set_waiting_period: boolean;
  accrue_start: string | undefined;

  // Employee Accrual Balance Cap
  set_max_balance: boolean;
  max_balance?: string;

  // Carryover Expiration
  reset_balance_yearly: boolean;
  max_carryover_balance?: any;

  // Leave Duration
  max_request_duration?: number | '';
  min_request_duration?: number | '';

  allow_negative_balance?: boolean;
  initial_Balance?: number;
}

const saveCategory = ({ id, ...postData }: ICategoryPostData) => {
  if (id) {
    return http().put(endpoints.timeOff.categoryById.replace('{id}', id), postData);
  }
  return http().post(endpoints.timeOff.category, postData);
};

export function useSaveCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveCategory,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchPaginatedCategory'] });
      }
    },
  });
}
